<template>
  <div class="gallery">
    <template v-if="galleryType === 'images' || !galleryType">
      <figure class="image" v-for="image in images" :key="image['ID']">
        <img :src="image['sizes']['large']">
        <figcaption v-if="image.caption" v-html="image.caption"></figcaption>
      </figure>
    </template>
    <template v-else-if="galleryType === 'embed'">
      <div class="video-embed" v-html="videoEmbed"></div>
    </template>
    <template v-else-if="galleryType === 'video'">
      <video class="video-file" controls autoplay playsinline :src="videoFileUrl"></video>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    gallery: Object
  },
  computed: {
    galleryType() {
      return this.gallery ? (this.gallery.type || 'images') : 'images'
    },
    images() {
      if (this.gallery) return this.gallery.images
    },
    videoEmbed() {
      if (this.gallery && this.gallery.video_embed) {
        let embed = this.gallery.video_embed
        // Add autoplay parameter to iframe src
        let srcMatch = embed.match(/src="([^"]+)"/)
        if (srcMatch) {
          let src = srcMatch[1]
          let newSrc = src.includes('?') ? src + '&autoplay=1' : src + '?autoplay=1'
          embed = embed.replace(`src="${src}"`, `src="${newSrc}"`)

          if (!embed.includes('allow=')) {
            embed = embed.replace('<iframe', '<iframe allow="autoplay" ')
          } else if (!embed.includes('autoplay')) {
            embed = embed.replace('allow="', 'allow="autoplay; ')
          }
        }
        return embed
      }
      return null
    },
    videoFileUrl() {
      if (this.gallery && this.gallery.video && typeof this.gallery.video === 'object') {
        return this.gallery.video.url
      }
      return null
    }
  }
}
</script>

<style scoped lang="scss">
.gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  .image {
    margin-bottom: 40px;

    img {
      max-width: 100%;
      height: auto;
    }
  }

  .video-embed,
  .video-file {
    width: 100%;
    max-width: 860px;
    margin-bottom: 40px;
  }

  .video-file {
    height: auto;
    aspect-ratio: 16 / 9;
  }
}
</style>

<style lang="scss">
.gallery {
  .video-embed iframe,
  .video-embed object,
  .video-embed embed {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
  }
}
</style>



// WEBPACK FOOTER //
// GalleryFull.vue?096fc8a8